import { cloneDeep } from 'lodash'
import store from '@/store'

export function insertGridLookUpExtraData (data) {
  const { gridId, cellKey } = data
  const { lookUpTable, displayColumn, dataGrids } = getLookUpData(data)

  for (let rowKey in dataGrids[gridId]) {
    const row = dataGrids[gridId][rowKey]

    delete row[`$${cellKey}`]
    delete row[`$${cellKey}$display`]

    if (!row[cellKey]) continue

    if (dataGrids[lookUpTable][row[cellKey]]) {
      row[`$${cellKey}`] = store.getters.$getLookUpRow(lookUpTable, row[cellKey])
      // store.getters.$getLookUpDisplayValue(lookUpTable, row[cellKey], displayColumn)
      Object.defineProperty(row, `$${cellKey}$display`, {
        configurable: true,
        enumerable: true,
        get() {
          return dataGrids[lookUpTable][row[cellKey]] && dataGrids[lookUpTable][row[cellKey]][displayColumn]
        }
      })
    } else {
      //console.error(`[DataGrid parser:insertGridLookUpExtraData] row "${row[cellKey]}" deosn't exist in "${lookUpTable}" DataGrid`)
    }
  }
}

export function insertCellLookUpExtraData (data) {
  const { gridId, rowKey, cellKey, state } = data
  const { lookUpTable, displayColumn, dataGrids } = getLookUpData(data)
  const row = state.models_dashboardModel[gridId][rowKey]

  delete row[`$${cellKey}`]
  delete row[`$${cellKey}$display`]

  if (!row[cellKey]) return

  if (dataGrids[lookUpTable][row[cellKey]]) {
    row[`$${cellKey}`] = store.getters.$getLookUpRow(lookUpTable, row[cellKey])

    Object.defineProperty(row, `$${cellKey}$display`, {
      configurable: true,
      enumerable: true,
      get() {
        return dataGrids[lookUpTable][row[cellKey]][displayColumn]
      }
    })
  } else {
    //console.error(`[DataGrid parser:insertGridLookUpExtraData] row "${row[cellKey]}" deosn't exist in "${lookUpTable}" DataGrid`)
  }
}

export function insertGridMultiLookUpExtraData (data) {
  const { gridId, cellKey } = data
  const { lookUpTable, displayColumn, dataGrids } = getLookUpData(data)

  for (let rowKey in dataGrids[gridId]) {
    const row = dataGrids[gridId][rowKey]

    delete row[`$${cellKey}`]
    delete row[`$${cellKey}$display`]

    if (!row[cellKey]) continue

    const $cell = {}
    const $cell$display = {}
    const lookups = row[cellKey].split(',')

    for (let lookup of lookups) {
      if (dataGrids[lookUpTable][lookup]) {
        $cell[lookup] = store.getters.$getLookUpRow(lookUpTable, lookup)

        Object.defineProperty($cell$display, lookup, {
          configurable: true,
          enumerable: true,
          get() {
            return dataGrids[lookUpTable][lookup][displayColumn]
          }
        })
      } else {
        //console.error(`[DataGrid parser:insertGridMultiLookUpExtraData] row "${lookup}" deosn't exist in "${lookUpTable}" DataGrid`)
      }
    }

    row[`$${cellKey}`] = $cell
    row[`$${cellKey}$display`] = $cell$display
  }
}

export function insertCellMultiLookUpExtraData (data) {
  const { gridId, rowKey, cellKey, state } = data
  const { lookUpTable, displayColumn, dataGrids } = getLookUpData(data)
  const row = state.models_dashboardModel[gridId][rowKey]

  delete row[`$${cellKey}`]
  delete row[`$${cellKey}$display`]

  if (!row[cellKey]) return

  const $cell = {}
  const $cell$display = {}
  const lookups = row[cellKey].split(',')

  for (let lookup of lookups) {
    if (dataGrids[lookUpTable][lookup]) {
      $cell[lookup] = store.getters.$getLookUpRow(lookUpTable, lookup)

      Object.defineProperty($cell$display, lookup, {
        configurable: true,
        enumerable: true,
        get() {
          return dataGrids[lookUpTable][lookup][displayColumn]
        }
      })
    } else {
      //console.error(`[DataGrid parser:insertGridMultiLookUpExtraData] row "${lookup}" deosn't exist in "${lookUpTable}" DataGrid`)
    }
  }

  row[`$${cellKey}`] = $cell
  row[`$${cellKey}$display`] = $cell$display
}

function getLookUpData (data) {
  const { state, allOptions, dgOptions, cellKey } = data
  const lookUpTable = dgOptions.meta[cellKey].lookUpTable
  const displayColumn = allOptions[lookUpTable].displayColumn
  const dataGrids = state.models_dashboardModel

  return { lookUpTable, displayColumn, dataGrids }
}
